import React from 'react';
import RequestSupportFormComponent from './request-support-form.component';

const RequestSupportForm = () => {
    return <RequestSupportFormComponent />;
};

export default RequestSupportForm;
